import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import { AnalysisVisitFieldsFragment } from './fragments';

export const VISIT_ANALYSIS = gql`
  mutation analysisVisit($input: AnalysisVisitInput!) {
    analysisVisit(input: $input) {
      errors {
        ...ErrorFields
      }
      visit {
        ...AnalysisVisitFields
      }
    }
  }
  ${ErrorFragment}
  ${AnalysisVisitFieldsFragment}
`;
